import React from 'react';
import PropTypes from 'prop-types';
import NativeClick, { METHODS } from '@ifit/mp-native-click';
import { scienceBlue, mountainMeadow } from '@ifit/base-coat/js/colors';
import { withTheme } from '@ifit/themes/withTheme';

export const lightBlue = '#0bb9e5';
export const yellowGreen = '#c0df16';

export const INITIAL_GROUPS = [
  { letters: ['A', 'B', 'C', 'D', 'E', 'F'], color: scienceBlue },
  { letters: ['G', 'H', 'I', 'J', 'K', 'L'], color: lightBlue },
  { letters: ['M', 'N', 'O', 'P', 'Q', 'R'], color: mountainMeadow },
  {
    letters: ['S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    color: yellowGreen,
  },
];

function getBackgroundColor(initials = '') {
  const initial = initials.toUpperCase()[0];
  if (!initial) return;

  const group = INITIAL_GROUPS.find(group => group.letters.includes(initial));
  return group && group.color;
}

function getInitialLetters(initials = '') {
  const isValid = /^[a-zA-Z]{1,2}/.test(initials);
  if (!isValid) return;

  return initials.slice(0, 2).toUpperCase();
}

export const Avatar = ({
  id,
  verbose,
  image,
  fallbackImage,
  initials,
  colorOverride,
  themeClass,
  wrapper: Wrapper,
}) => {
  const _initials = getInitialLetters(initials);
  const colors = colorOverride || getBackgroundColor(_initials);
  const backgroundColor = colors ? colors : '';
  const background = !_initials
  ? `${backgroundColor} url(${
      image || fallbackImage
    }) center center / cover no-repeat`
  : backgroundColor;

  const Component = (
    <div
      className={`avatar ${themeClass}`}
      style={{ background }}
    >
      {_initials}
    </div>
  );
  if (!id) return Component;
  if (Wrapper) {
    return (
      <Wrapper>
        {Component}
      </Wrapper>
    )
  }
  return (
    <NativeClick verbose={verbose} objectToSend={METHODS.trainerSelected(id)}>
      {Component}
    </NativeClick>
  );
};

Avatar.propTypes = {
  image: PropTypes.string.isRequired,
  verbose: PropTypes.bool,
  fallbackImage: PropTypes.string,
  id: PropTypes.string,
  themeClass: PropTypes.string,
  /** When provided, component will render default avatar with supplied initials */
  initials: PropTypes.string,
  /** Overrides default background color for default avatar */
  colorOverride: PropTypes.string,
  wrapper: PropTypes.elementType,
};

Avatar.displayName = 'Card.Avatar';

export default withTheme(Avatar);
